import API from "../shared/API/apiClient";

export const getLocationDistribution = (
  reporting_year,
  filter_type = "",
  from_date = "",
  to_date = "",
  legal_entity_id = "",
  reporting_year_id = ""
) => {
  return API.get("/api/reports/location-distribution", {
    params: {
      reporting_year,
      filter_type,
      from_date,
      to_date,
      legal_entity_id,
      reporting_year_id,
    },
  });
};